export const FAQs = [
    {
        question: "At what types of events do you speak?",
        answers: [
            "I am honored to do Conferences, Retreats, Key-Note Messages, Breakouts, Christmas and Spring Teas, MOPS Meetings, Young Adult Events... honestly, any opportunity to share the hope that comes from pressing into a relationship with Jesus!", 
            "Share your idea with me through our contact form and let's talk!"
         ]
    },
    {
        question: "What topics do you speak on?",
        answers: [
            "I'm willing to prepare messages based on the theme you've chosen for your event, but also have other topics that I've already prepared:",
            "A Passionate Heart",
            "The Heart of our Rock",
            "Finishing Strong",
            "Strength Training",
            "The God Who Sees...",
            "What if...",
            "Mary Did You Know?",
            "...and more!"
        ]
    },
    {
        question: "What is your fee?",
        answers: [
            "It is my absolute honor to share with women the hope that comes from Jesus! I love seeing the light in their eyes as they begin to catch a glimpse of the depth of His great love for them!",
            "I do not have a set fee. I ask for travel expenses/meals to be covered, and if at all possible, a private room if it is an overnight event. Any honorarium beyond that is whatever your budget allows.",
        ]
    },
]